module.exports = __webpack_public_path__ + "static/media/show-assets.9251ae61.svg";